<template>
  <span class="inline-flex items-center gap-1" :class="align === 'left' ? 'justify-start' : 'justify-end'">
    <span>{{ label }}<slot /></span>
    <button
      v-if="hasInfo"
      ref="trigger"
      type="button"
      class="inline-flex items-center border-0 bg-transparent p-0 leading-none"
      :class="open ? 'text-sky-600' : 'text-gray-300 hover:text-sky-600'"
      :aria-label="`How ${label} is calculated`"
      :aria-expanded="open ? 'true' : 'false'"
      :aria-describedby="open ? tooltipId : undefined"
      @click.stop="toggle"
      @mouseenter="show(false)"
      @mouseleave="hideHover"
      @focus="show(false)"
      @blur="hideHover"
    >
      <FontAwesomeIcon :icon="['fas', 'circle-info']" style="font-size: 9px;" />
    </button>
    <Teleport v-if="hasInfo && open" to="body">
      <span
        :id="tooltipId"
        role="tooltip"
        class="fixed z-[1000] block w-64 rounded-md bg-gray-900 px-2.5 py-2 text-left text-xs font-normal leading-snug text-white shadow-lg whitespace-normal"
        :style="position"
        @click.stop
      >
        <span v-if="definition" class="block text-gray-200">{{ definition }}</span>
        <span v-if="reason" class="block text-amber-300" :class="{ 'mt-1': definition }">{{ reason }}</span>
      </span>
    </Teleport>
  </span>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const WIDTH = 256;
const MARGIN = 8;
let nextId = 0;

export default {
  name: 'OperationsColumnHeader',
  components: { FontAwesomeIcon },
  props: {
    label: { type: String, required: true },
    definition: { type: String, default: '' },
    reason: { type: String, default: '' },
    align: { type: String, default: 'right' },
  },
  data() {
    nextId += 1;
    return { open: false, pinned: false, position: {}, tooltipId: `operations-column-def-${nextId}` };
  },
  computed: {
    hasInfo() {
      return Boolean(this.definition || this.reason);
    },
  },
  beforeUnmount() {
    this.unlisten();
  },
  methods: {
    place() {
      const rect = this.$refs.trigger?.getBoundingClientRect();
      if (!rect) return;
      const preferred = this.align === 'left' ? rect.left : rect.right - WIDTH;
      const left = Math.min(Math.max(MARGIN, preferred), window.innerWidth - WIDTH - MARGIN);
      this.position = { top: `${rect.bottom + 6}px`, left: `${left}px` };
    },
    show(pinned) {
      this.place();
      this.pinned = this.pinned || pinned;
      if (!this.open) {
        this.open = true;
        document.addEventListener('click', this.close);
        window.addEventListener('scroll', this.close, true);
        window.addEventListener('resize', this.close);
      }
    },
    hideHover() {
      if (!this.pinned) this.close();
    },
    toggle() {
      if (this.open && this.pinned) this.close();
      else this.show(true);
    },
    close() {
      this.open = false;
      this.pinned = false;
      this.unlisten();
    },
    unlisten() {
      document.removeEventListener('click', this.close);
      window.removeEventListener('scroll', this.close, true);
      window.removeEventListener('resize', this.close);
    },
  },
};
</script>
